/*
 *
 * PrivacyConsentsModal
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 26-Mar-2025
*/

import PrivacyConsentsModal from './PrivacyConsentsModalContainer'

export default PrivacyConsentsModal
